module.exports = __webpack_public_path__ + "img/bg.4e929657.png";